import './bootstrap';
import '../css/app.css';
import { createApp } from 'vue';
// import { createRouter, createWebHistory } from 'vue-router';
import App from './Layouts/App.vue';

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {dom, library} from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import {faLock, faEnvelope} from '@fortawesome/free-solid-svg-icons';
import {faFacebook, faGooglePlus} from '@fortawesome/free-brands-svg-icons';

import _ from 'underscore';
// Test
// Import AdminLTE scripts ( uncomment as necessary)
import * as Adminlte from "admin-lte/dist/js/adminlte.js"
// import "admin-lte/plugins/select2/js/select2.full.min.js"
import "admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js"
import "admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js"
//import "admin-lte/plugins/summernote/summernote-bs4.min.js"
//import "admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js"
import "admin-lte/plugins/daterangepicker/daterangepicker.js"
//mport "admin-lte/plugins/moment/moment.min.js"

import "admin-lte/plugins/jquery-knob/jquery.knob.min.js"
//import "admin-lte/plugins/jqvmap/maps/jquery.vmap.usa.js"
//import "admin-lte/plugins/jqvmap/jquery.vmap.min.js"
import "admin-lte/plugins/sparklines/sparkline.js"
//import "admin-lte/plugins/chart.js/Chart.min.js"
import "admin-lte/plugins/jquery/jquery.min.js"
import "admin-lte/plugins/jquery-ui/jquery-ui.min.js"

// import "admin-lte/plugins/inputmask/jquery.inputmask.min.js"
//import "admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js"
import "admin-lte/plugins/bootstrap-switch/js/bootstrap-switch.min.js"
// import "admin-lte/plugins/bs-stepper/js/bs-stepper.min.js"
// import "admin-lte/plugins/dropzone/min/dropzone.min.js"
// import bsCustomFileInput from "admin-lte/plugins/bs-custom-file-input/bs-custom-file-input.js";

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import router from './routes/index';
// import { pinia } from './pinia';
import { createPinia } from 'pinia';
import piniaPluginPesistedstate from 'pinia-plugin-persistedstate';
// import store from '@/store';

import { Form, Field, ErrorMessage } from '@/Components/Validators/index.js';
import LoadingComponent from '@/Components/Loading.vue';
import numeral from 'numeral';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { getLocaleMessage } from '@/services/MessagesService';
// import treeViewInitOnce from '@/Plugins/TreeviewFix.js';

let treeViewInit = function(){
    $('[data-widget="treeview"]').each(function () {
        Adminlte.Treeview._jQueryInterface.call(
            $(this),
            "init"
        );
    });
};

let treeViewInitOnce = _.once(treeViewInit);

numeral.register('locale', 'es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'mm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        var b = number % 10;
        return (b === 1 || b === 3) ? 'er' :
            (b === 2) ? 'do' :
                (b === 7 || b === 0) ? 'mo' :
                    (b === 8) ? 'vo' :
                        (b === 9) ? 'no' : 'to';
    },
    currency: {
        symbol: '$'
    }
});

// const localeMessagesPlugin = {
//     install(app) {
//       app.config.globalProperties.$getLocaleMessage = getLocaleMessage;
//     },
//   };

const pinia = createPinia();
pinia.use(piniaPluginPesistedstate);
const app = createApp(App);

app.config.globalProperties.$filters = {
    formatNumber(value) {
        if (value == null || typeof value === 'undefined') return;
    
        // Convertir a número si es string
        const numericValue = typeof value === 'string' ? parseFloat(value) : value;
        
        // Manejar NaN después de conversión
        if (isNaN(numericValue)) return;
        
        // Redondear a 2 decimales y verificar si es cero efectivo
        const rounded = Math.round(numericValue * 100) / 100;
        if (rounded === 0) {
            return '$0.00';
        }
        
        return numeral(numericValue).format('$0,0.00');
    },
    formatPercent(value) {
        if (value == null || typeof value == undefined) return;
        return numeral(value).format('0.00%');
    },
    formatPercent2(value) {
        if (value == null || typeof value == undefined) return;
        const p = value / 100;
        return numeral(p).format('0.0%');
    },
    // Date value is expected to be in ISO 8601 format (E.g: 2024-04-17T00:00:00)
    formatDate(value, fmt="dd 'de' MMM 'del' yyy") {
        if (value == null || typeof value == undefined) return;
        const date = new Date(value);
        const res = format(date, fmt, {
            locale: es
          })
        return res;
    },
    formatDateView(dateString) {
        if (!dateString) return ''; // Manejo de valores nulos
        
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van de 0-11
        const year = date.getFullYear();
        
        return `${day}/${month}/${year}`;
    },
    formatDateSNTimeView(dateString) {
        if (!dateString) return '';

        const [year, month, day] = dateString.split('-');

        return `${day}/${month}/${year}`;
    },
    //Función para formatear fechas para la entrada del input date ya que venia como 2025-05-02
    formatDateForInput(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    },
    //Función para transformar una cantidad en números a la lectura en texto de esa cantidad
    numeroALetras(numero) {
        const partes = numero.toString().split('.');
        const entero = parseInt(partes[0]) || 0;
        const decimal = parseInt(partes[1]?.substring(0, 3)) || 0;

        const unidades = ['', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
        const decenas = ['', 'diez', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
        const especiales = ['diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve'];
        const centenas = ['', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos'];

        function convertirMenorMil(n) {
            if (n === 0) return '';
            let resultado = '';
            
            if (n >= 100) {
                resultado += centenas[Math.floor(n / 100)] + ' ';
                n %= 100;
            }

            if (n >= 20) {
                resultado += decenas[Math.floor(n / 10)] + (n % 10 !== 0 ? ' y ' + unidades[n % 10] : '');
            } else if (n >= 10) {
                resultado += especiales[n - 10];
            } else if (n > 0) {
                resultado += unidades[n];
            }

            return resultado.trim();
        }

        let letras = '';
        const millones = Math.floor(entero / 1000000);
        const restoMillones = entero % 1000000;
        
        if (millones > 0) {
            letras += convertirMenorMil(millones) + ' millón' + (millones > 1 ? 'es ' : ' ');
        }
        
        const miles = Math.floor(restoMillones / 1000);
        const restoMiles = restoMillones % 1000;
        
        if (miles > 0) {
            letras += convertirMenorMil(miles) + ' mil ';
        }
        
        if (restoMiles > 0 || (millones === 0 && miles === 0)) {
            letras += convertirMenorMil(restoMiles);
        }

        if (decimal > 0) {
            letras += ' con ' + convertirMenorMil(decimal);
        }

        // Ajustes gramaticales
        letras = letras.replace(/veinte y uno/g, 'veintiuno');
        letras = letras.replace(/veinte y dos/g, 'veintidós');
        letras = letras.replace(/uno mil/g, 'un mil'); // Corrección para "un mil"
        letras = letras.replace(/uno millón/g, 'un millón'); // Corrección para "un millón"

        return letras.trim();
    },
    porcentajeALetras(porcentaje) {
        // Eliminar el signo de porcentaje si existe
        const numeroStr = porcentaje.toString().replace('%', '');
        
        // Separar parte entera y decimal
        const partes = numeroStr.split('.');
        const entero = partes[0];
        const decimal = partes.length > 1 ? partes[1] : '00';
        
        // Objeto para mapear números a palabras
        const numerosAPalabras = {
            0: 'cero',
            1: 'uno',
            2: 'dos',
            3: 'tres',
            4: 'cuatro',
            5: 'cinco',
            6: 'seis',
            7: 'siete',
            8: 'ocho',
            9: 'nueve',
            10: 'diez',
            11: 'once',
            12: 'doce',
            13: 'trece',
            14: 'catorce',
            15: 'quince',
            16: 'dieciséis',
            17: 'diecisiete',
            18: 'dieciocho',
            19: 'diecinueve',
            20: 'veinte',
            21: 'veintiuno',
            22: 'veintidós',
            23: 'veintitrés',
            24: 'veinticuatro',
            25: 'veinticinco',
            26: 'veintiséis',
            27: 'veintisiete',
            28: 'veintiocho',
            29: 'veintinueve',
            30: 'treinta',
            40: 'cuarenta',
            50: 'cincuenta',
            60: 'sesenta',
            70: 'setenta',
            80: 'ochenta',
            90: 'noventa',
            100: 'cien'
        };
        
        // Función para convertir números de dos dígitos
        function convertirDosDigitos(num) {
            if (numerosAPalabras[num]) {
                return numerosAPalabras[num];
            } else {
                const decenas = Math.floor(num / 10) * 10;
                const unidades = num % 10;
                return `${numerosAPalabras[decenas]} y ${numerosAPalabras[unidades]}`;
            }
        }
        
        // Convertir parte entera
        let resultado = '';
        const numEntero = parseInt(entero);
        
        if (numEntero <= 30 || (numEntero <= 100 && numEntero % 10 === 0)) {
            resultado = numerosAPalabras[numEntero] || convertirDosDigitos(numEntero);
        } else {
            resultado = convertirDosDigitos(numEntero);
        }
        
        // Convertir parte decimal
        if (decimal !== '00') {
            const numDecimal = parseInt(decimal);
            let decimalTexto;
            
            if (numDecimal <= 30 || (numDecimal <= 100 && numDecimal % 10 === 0)) {
                decimalTexto = numerosAPalabras[numDecimal] || convertirDosDigitos(numDecimal);
            } else {
                decimalTexto = convertirDosDigitos(numDecimal);
            }
            
            resultado += ` punto ${decimalTexto}`;
        }
        
        return resultado;
    },
    // Fecha formateada dd/mm/yyyy - solo para visualización
    formattedDateDistribution(dateString) {
        if (!dateString) return '';
        
        try {
            // Método directo para formato ISO: 2025-09-22T00:00:00
            if (typeof dateString === 'string' && dateString.includes('T')) {
                const [datePart] = dateString.split('T');
                const [year, month, day] = datePart.split('-');
                
                if (year && month && day) {
                    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
                }
            }
            
            // Fallback: usar Date object
            const date = new Date(dateString);
            if (!isNaN(date.getTime())) {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            }
            
            return dateString;
            
        } catch (error) {
            console.error('Error formateando fecha:', error);
            return dateString;
        }
    },
    // Formatear Fecha de tipo 2025-09-12T00:00:00 a 09/12/2025
    formattedDateConvertView(valueDate){
        const date = new Date(valueDate);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Enero = 0
        const year = date.getFullYear();

        const formatted = `${month}/${day}/${year}`; // "09/12/2025"
        return formatted;
    },
    // Formatear Fecha de tipo 2025-09-12 a 12/09/2025
    formatDateDDMMYYY(dateString) {
        if (!dateString) return '';

        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    }
}

app.config.globalProperties.$treeViewInitOnce = treeViewInitOnce;
app.config.globalProperties.$getLocaleMessage = getLocaleMessage;
app.config.errorHandler = (err, instance, info) => {
    // Log the error to the console
    console.error('Vue error:', err, instance, info);
  
    // Send the error to Sentry
    // Sentry.captureException(err);
  };

app.component('Form', Form)
app.component('Field', Field)
app.component('ErrorMessage', ErrorMessage)
app.component('LoadingComponent', LoadingComponent)
app.component('v-select', vSelect)
app.component(FontAwesomeIcon)
// app.use(fas, fab, far, faLock, faEnvelope, faFacebook, faGooglePlus)
app.use(router)
app.use(pinia)
app.mount('#app');